{
  "page": {
    "title": "Cài đặt hệ thống"
  },

  "tabs": {
    "practiceInfo": "Thông tin tổ chức",
    "system": "Hệ thống",
    "documentNumbering": "Số chứng từ",
    "notifications": "Thông báo",
    "booking": "Đặt lịch",
    "payment": "Thanh toán",
    "automation": "Tự động hóa",
    "security": "Bảo mật",
    "integrations": "Tích hợp",
    "backupRestore": "Sao lưu & Khôi phục"
  },

  "actions": {
    "saveChanges": "Lưu thay đổi",
    "saving": "Đang lưu...",
    "save": "Lưu",
    "undo": "Hoàn tác",
    "edit": "Chỉnh sửa",
    "cancel": "Hủy"
  },

  "practiceInfo": {
    "adminOnlyWarning": "Chỉ quản trị viên mới có thể chỉnh sửa cài đặt tổ chức.",
    "fields": {
      "practiceName": "Tên tổ chức",
      "email": "Email",
      "phone": "Số điện thoại",
      "phonePlaceholder": "Ví dụ: 0901234567",
      "website": "Trang web",
      "websitePlaceholder": "https://example.com",
      "streetAddress": "Địa chỉ (Số nhà, Tên đường)",
      "ward": "Phường/Xã",
      "province": "Tỉnh/Thành phố",
      "country": "Quốc gia",
      "taxCode": "Mã số thuế"
    },
    "placeholders": {
      "practiceName": "Nhập tên tổ chức",
      "email": "email@example.com",
      "street": "Số nhà, tên đường",
      "ward": "Chọn phường/xã",
      "province": "Chọn tỉnh/thành phố",
      "taxCode": "Nhập mã số thuế"
    }
  },

  "system": {
    "adminOnlyWarning": "Chỉ quản trị viên mới có thể chỉnh sửa cài đặt tổ chức.",
    "title": "Cài đặt hệ thống",
    "infoNotice": "Định dạng ngày, định dạng giờ, múi giờ và đơn vị tiền tệ được lưu theo tổ chức và ảnh hưởng đến cách hiển thị ngày giờ trong toàn bộ ứng dụng. Chỉ ICT và VND được cố định trong giai đoạn thị trường Việt Nam. Các tùy chọn khác dưới đây chỉ để xem trước.",
    "fields": {
      "theme": "Giao diện",
      "language": "Ngôn ngữ",
      "dateFormat": "Định dạng ngày",
      "timeFormat": "Định dạng giờ",
      "timezone": "Múi giờ",
      "currency": "Đơn vị tiền tệ",
      "diagnosisCodingSystem": "Chuẩn chẩn đoán ICD",
      "autoLogout": "Tự động đăng xuất (phút)",
      "dataRetention": "Thời gian lưu trữ dữ liệu (năm)",
      "updateCheck": "Tự động kiểm tra cập nhật",
      "viewportEnabled": "Chặn khi độ phân giải quá nhỏ",
      "viewportMinWidth": "Chiều rộng tối thiểu (px)",
      "viewportMinHeight": "Chiều cao tối thiểu (px)",
      "kpiInnerPerSession": "Đơn giá ca phụ tá vòng trong (VND)",
      "kpiOuterPerSession": "Đơn giá ca phụ tá vòng ngoài (VND)"
    },
    "kpiAssistantRates": {
      "title": "Thưởng ca phụ tá (KPI)",
      "hint": "Khi chốt phiếu KPI, số ca vòng trong/ngoài × đơn giá này thành tiền thưởng đưa vào kỳ lương (cùng tháng). Đặt 0 nếu chưa trả theo ca."
    },
    "viewport": {
      "title": "Độ phân giải trình duyệt",
      "hint": "Khi bật, người dùng đã đăng nhập sẽ thấy màn hình cảnh báo nếu cửa sổ trình duyệt nhỏ hơn ngưỡng (tính cả zoom). Trang đăng nhập và đổi mật khẩu không bị chặn.",
      "minWidthHelper": "Mặc định 1280. Gợi ý: 1024, 1280, 1440.",
      "minHeightHelper": "Đặt 0 để không kiểm tra chiều cao."
    },
    "diagnosisCoding": {
      "icd10": "ICD-10",
      "icd11": "ICD-11",
      "hint": "Mỗi tổ chức chỉ dùng một chuẩn ICD tại một thời điểm. Chẩn đoán nội bộ (custom) luôn dùng được song song. Đổi chuẩn không xóa mã chuẩn cũ."
    }
  },

  "notifications": {
    "adminOnlyWarning": "Chỉ quản trị viên mới có thể chỉnh sửa cài đặt thông báo.",
    "title": "Cài đặt thông báo",
    "infoNotice": "Các cài đặt này bật/tắt kênh thông báo trong ứng dụng. Chi tiết quy tắc (nội dung, người nhận) xem tab Tự động hóa. Thời gian nhắc lịch dùng số giờ cấu hình dưới đây.",
    "sections": {
      "appointments": "Thông báo lịch hẹn",
      "patientTreatment": "Bệnh nhân & Điều trị",
      "tasks": "Công việc",
      "internalChat": "Chat nội bộ",
      "leave": "Nghỉ phép & lương",
      "inventoryPayment": "Kho & Thanh toán",
      "system": "Thông báo hệ thống"
    },
    "fields": {
      "appointmentCreated": "Thông báo khi có lịch hẹn mới được tạo",
      "appointmentReminders": "Gửi nhắc nhở lịch hẹn",
      "appointmentReminderTime": "Thời gian nhắc nhở (giờ trước lịch hẹn)",
      "appointmentRescheduled": "Thông báo khi lịch hẹn được đổi lịch",
      "appointmentCancelled": "Thông báo khi lịch hẹn bị hủy",
      "missedAppointments": "Thông báo khi bệnh nhân không đến (no-show)",
      "newPatients": "Thông báo khi có bệnh nhân mới đăng ký",
      "taskDueReminders": "Nhắc công việc quá hạn và sắp đến hạn",
      "internalChatMessages": "Thông báo tin nhắn chat nội bộ",
      "leaveRequests": "Thông báo đơn xin nghỉ (tạo, duyệt, từ chối, hủy)",
      "salaryAdvances": "Thông báo đơn xin tạm ứng (tạo, duyệt, từ chối, hủy, chi)",
      "treatmentCompleted": "Thông báo khi kế hoạch điều trị hoàn thành",
      "lowInventory": "Thông báo khi kho hàng sắp hết",
      "payments": "Thông báo khi nhận được thanh toán",
      "systemUpdates": "Nhận thông báo cập nhật hệ thống"
    }
  },

  "security": {
    "title": "Cài đặt bảo mật",
    "passwordPolicy": "Chính sách mật khẩu",
    "authentication": "Xác thực 2 yếu tố",
    "ipRestriction": "Giới hạn IP",
    "idleLogout": "Đăng xuất tự động",
    "fields": {
      "passwordExpiry": "Thời hạn mật khẩu (ngày)",
      "passwordExpiryHelper": "Đặt 0 để không hết hạn mật khẩu",
      "passwordMinLength": "Độ dài mật khẩu tối thiểu",
      "passwordMinLengthHelper": "Từ 6 đến 72 ký tự",
      "requireUppercase": "Yêu cầu chữ hoa",
      "requireLowercase": "Yêu cầu chữ thường",
      "requireSpecialChars": "Yêu cầu ký tự đặc biệt (@$!%*?&)",
      "requireNumbers": "Yêu cầu số",
      "twoFactorAuth": "Yêu cầu xác thực hai yếu tố",
      "twoFactorAuthDescription": "Khi bật, mọi thành viên tổ chức phải thiết lập 2FA trước khi dùng hệ thống.",
      "idleLogoutMinutes": "Tự động đăng xuất khi không thao tác (phút)",
      "idleLogoutHelper": "Đặt 0 để tắt. Áp dụng khi người dùng không tương tác với hệ thống.",
      "ipRestriction": "Bật giới hạn địa chỉ IP",
      "allowedIPs": "Địa chỉ IP được phép (phân tách bằng dấu phẩy)",
      "allowedIPsHelper": "Hỗ trợ IP hoặc CIDR, ví dụ: 192.168.1.1, 10.0.0.0/8"
    },
    "allowedIpsRequired": "Vui lòng nhập ít nhất một IP khi bật giới hạn IP",
    "saveSuccess": {
      "passwordPolicy": "Đã lưu chính sách mật khẩu",
      "authentication": "Đã lưu cài đặt xác thực",
      "ipRestriction": "Đã lưu giới hạn IP",
      "idleLogout": "Đã lưu đăng xuất tự động"
    },
    "saveFailed": {
      "passwordPolicy": "Lưu chính sách mật khẩu thất bại",
      "authentication": "Lưu cài đặt xác thực thất bại",
      "ipRestriction": "Lưu giới hạn IP thất bại",
      "idleLogout": "Lưu đăng xuất tự động thất bại"
    }
  },

  "payment": {
    "title": "Thanh toán & TK nạp trước",
    "adminOnlyWarning": "Chỉ quản trị viên mới có thể chỉnh sửa cài đặt thanh toán.",
    "infoNotice": "Áp dụng cho toàn tổ chức. Tắt tính năng sẽ ẩn trên giao diện và chặn thao tác ghi mới (dữ liệu cũ vẫn xem được).",
    "saveSuccess": "Đã lưu cài đặt thanh toán",
    "saveFailed": "Lưu cài đặt thanh toán thất bại",
    "fields": {
      "walletEnabled": "Bật tài khoản nạp trước",
      "planAdvanceEnabled": "Bật tạm ứng theo kế hoạch"
    },
    "helpers": {
      "walletEnabled": "Nạp tiền, thanh toán dịch vụ bằng số dư TK nạp trước.",
      "planAdvanceEnabled": "Thu tạm ứng gắn kế hoạch điều trị (khác TK nạp trước)."
    }
  },

  "booking": {
    "title": "Chính sách đặt lịch",
    "adminOnlyWarning": "Chỉ quản trị viên mới có thể chỉnh sửa chính sách đặt lịch.",
    "infoNotice": "Quy tắc mặc định cho toàn tổ chức. Từng phòng khám có thể ghi đè riêng trên form sửa phòng khám.",
    "saveSuccess": "Đã lưu chính sách đặt lịch",
    "saveFailed": "Lưu chính sách đặt lịch thất bại",
    "fields": {
      "dentistOverlap": "Trùng lịch bác sĩ",
      "chairOverlap": "Trùng lịch ghế",
      "clinicHours": "Ngày & giờ phòng khám",
      "staffSchedule": "Lịch làm của bác sĩ",
      "requireChair": "Bắt buộc chọn ghế",
      "slotStepMinutes": "Bước khung giờ (phút)",
      "bufferBefore": "Buffer trước (phút)",
      "bufferBeforeHelper": "Khoảng trống bắt buộc trước lịch hẹn khi kiểm tra trùng",
      "bufferAfter": "Buffer sau (phút)",
      "bufferAfterHelper": "Khoảng trống bắt buộc sau lịch hẹn khi kiểm tra trùng",
      "minLeadMinutes": "Đặt trước tối thiểu (phút)",
      "minLeadMinutesHelper": "0 = không giới hạn. Ví dụ 60 = phải đặt trước ít nhất 1 giờ",
      "maxAdvanceDays": "Đặt trước tối đa (ngày)",
      "maxAdvanceDaysHelper": "0 = không giới hạn. Ví dụ 90 = không cho đặt xa hơn 90 ngày"
    },
    "overlapModes": {
      "block": "Chặn (không cho đặt)",
      "warn": "Cảnh báo (xác nhận mới đặt)",
      "allow": "Cho phép trùng"
    },
    "scheduleModes": {
      "block": "Chặn (không cho đặt)",
      "warn": "Cảnh báo (xác nhận mới đặt)",
      "allow": "Cho đặt"
    },
    "requireChairModes": {
      "if_configured": "Khi phòng khám đã có ghế",
      "always": "Luôn bắt buộc",
      "never": "Không bắt buộc"
    }
  },

  "integrations": {
    "title": "Cài đặt tích hợp",
    "nav": {
      "email": "Email",
      "emailProvider": "SMTP",
      "messaging": "Messaging",
      "messagingProvider": "Pancake",
      "voicecloud": "SMS / ZNS",
      "voicecloudProvider": "VoiceCloud",
      "omicall": "Tổng đài",
      "omicallProvider": "Omicall"
    },
    "paymentGateway": "Cổng thanh toán",
    "smsProvider": "Nhà cung cấp SMS",
    "emailProvider": "Nhà cung cấp Email",
    "calendarIntegration": "Tích hợp lịch",
    "comingSoonOther": "Thanh toán và Lịch",
    "status": {
      "enabled": "Đang bật",
      "disabled": "Đang tắt",
      "comingSoon": "Sắp có"
    },
    "fields": {
      "apiKey": "API Key",
      "calendarSync": "Bật đồng bộ lịch",
      "googleCalendarId": "Google Calendar ID"
    },
    "emailProviderOptions": {
      "smtp": "SMTP tùy chỉnh"
    },
    "email": {
      "title": "Email (SMTP)",
      "subtitle": "Cấu hình SMTP theo tổ chức. Không dùng biến môi trường máy chủ — phải bật và lưu tại đây trước khi gửi email.",
      "readOnly": "Chỉ quản trị viên mới chỉnh được cấu hình tích hợp.",
      "disabledHint": "Email đang tắt. Automation, nhắc lịch và đặt lại mật khẩu sẽ báo lỗi cho đến khi bạn bật và lưu cấu hình.",
      "testTitle": "Gửi email thử",
      "lastTest": "Lần kiểm tra gần nhất: {{status}}",
      "testStatus": {
        "success": "thành công",
        "failure": "thất bại"
      },
      "fields": {
        "enabled": "Bật gửi email",
        "service": "Dịch vụ SMTP",
        "servicePlaceholder": "Chọn dịch vụ SMTP",
        "host": "Host SMTP",
        "port": "Port",
        "secure": "TLS/SSL (secure)",
        "username": "Tên đăng nhập",
        "password": "Mật khẩu",
        "passwordKeep": "Để trống nếu giữ mật khẩu hiện tại",
        "passwordNew": "Nhập mật khẩu SMTP",
        "passwordHint": "Để trống để giữ mật khẩu đã lưu. Chỉ nhập khi muốn đổi.",
        "fromEmail": "Email người gửi",
        "fromName": "Tên người gửi",
        "fromNamePlaceholder": "Nha khoa Tân Định",
        "testToEmail": "Gửi email thử tới",
        "testToEmailPlaceholder": "name@example.com"
      },
      "placeholders": {
        "gmail": {
          "username": "name@gmail.com",
          "fromEmail": "name@gmail.com",
          "passwordNew": "Mật khẩu ứng dụng Gmail"
        },
        "outlook": {
          "username": "name@outlook.com",
          "fromEmail": "name@outlook.com"
        },
        "yahoo": {
          "username": "name@yahoo.com",
          "fromEmail": "name@yahoo.com"
        },
        "smtp": {
          "host": "smtp.example.com",
          "username": "name@example.com",
          "fromEmail": "noreply@example.com"
        }
      },
      "actions": {
        "save": "Lưu cấu hình email",
        "test": "Gửi thử"
      },
      "validation": {
        "requiredFields": "Vui lòng nhập username và email người gửi.",
        "invalidFromEmail": "Email người gửi không hợp lệ.",
        "serviceRequired": "Vui lòng chọn dịch vụ SMTP.",
        "serviceOrHost": "Nhập host SMTP cho cấu hình tùy chỉnh.",
        "passwordRequired": "Cần mật khẩu SMTP để bật email.",
        "invalidTestEmail": "Email nhận thử không hợp lệ."
      },
      "errors": {
        "notConfigured": "Chưa cấu hình email. Vào Cài đặt → Tích hợp để thiết lập SMTP.",
        "disabled": "Tích hợp email đang tắt. Bật trong Cài đặt → Tích hợp.",
        "sendFailed": "Gửi email thất bại. Kiểm tra lại thông tin SMTP."
      },
      "messages": {
        "saved": "Đã lưu cấu hình email",
        "saveError": "Không lưu được cấu hình email",
        "loadError": "Không tải được cấu hình email",
        "testSent": "Đã gửi email thử",
        "testError": "Gửi email thử thất bại"
      },
      "deliveries": {
        "title": "Lịch sử gửi gần đây",
        "subtitle": "Mọi lần gửi qua cổng email (thành công hoặc thất bại).",
        "refresh": "Làm mới",
        "empty": "Chưa có lần gửi nào.",
        "loadError": "Không tải được lịch sử gửi email.",
        "columns": {
          "time": "Thời gian",
          "to": "Người nhận",
          "subject": "Tiêu đề",
          "source": "Nguồn",
          "status": "Trạng thái",
          "error": "Lỗi"
        },
        "status": {
          "sent": "Thành công",
          "failed": "Thất bại"
        },
        "sources": {
          "automation": "Automation",
          "auth": "Đặt lại mật khẩu",
          "reminder": "Nhắc lịch",
          "test": "Kiểm tra SMTP",
          "manual": "Thủ công"
        }
      }
    },
    "messaging": {
      "title": "Messaging (Pancake)",
      "subtitle": "Kết nối từng page Pancake (page_id + page_access_token từ Tools). CRM (Lead/Patient) chỉ sống trên DentOS — không đẩy ngược lên Pancake.",
      "readOnly": "Cần quyền messaging:manage để chỉnh cấu hình.",
      "fields": {
        "enabled": "Bật messaging",
        "pageN": "Page {{n}}",
        "pageId": "Page ID (Pancake)",
        "pageAccessToken": "Page Access Token",
        "pageAccessTokenHint": "Để trống nếu giữ token đã lưu.",
        "channel": "Kênh",
        "label": "Nhãn",
        "webhookSecret": "Webhook secret",
        "webhookSecretHint": "Copy URL rồi dán vào mục Webhook trên Pancake.",
        "lastSyncAt": "Lần đồng bộ gần nhất",
        "lastWebhookAt": "Webhook gần nhất"
      },
      "inbound": {
        "webhookHint": "Pancake đẩy tin ngay khi có. Copy URL webhook rồi dán vào Pancake Tools."
      },
      "connection": {
        "title": "Kết nối Pancake",
        "active": "Đã kết nối",
        "connecting": "Đang kết nối",
        "disconnected": "Chưa kết nối",
        "realtimeActive": "Tin nhắn mới: Hoạt động",
        "realtimeWaiting": "Tin nhắn mới: Chưa nhận webhook"
      },
      "sync": {
        "historyTitle": "Lịch sử tin nhắn",
        "idle": "Chưa đồng bộ",
        "initializing": "Đang đồng bộ…",
        "backfilling": "Đang tải lịch sử…",
        "synced": "Đã đồng bộ",
        "partial": "Đồng bộ một phần",
        "failed": "Đồng bộ thất bại",
        "lastReconcile": "Lần cuối {{time}}",
        "pageLine": "{{name}} — {{status}}",
        "tierProgress": "Tier {{tier}} · {{conversations}} hội thoại · từ {{from}}",
        "listProgress": "Đã quét {{listed}} hội thoại",
        "hydrateProgress": "Đã tải tin {{hydrated}}/{{target}} cuộc gần nhất"
      },
      "channels": {
        "facebook": "Facebook",
        "instagram": "Instagram",
        "zalo": "Zalo",
        "tiktok": "TikTok",
        "whatsapp": "WhatsApp",
        "other": "Khác"
      },
      "emptyPages": "Chưa kết nối page nào. Kết nối từng page từ Pancake Tools.",
      "webhook": {
        "configured": "Webhook đã cấu hình. Copy URL rồi dán vào mục Webhook trên Pancake.",
        "copyNow": "Secret vừa tạo — copy URL ngay và cập nhật trên Pancake. URL cũ sẽ không còn dùng được."
      },
      "actions": {
        "save": "Lưu messaging",
        "copyUrl": "Copy URL",
        "rotateSecret": "Tạo secret webhook mới",
        "connectPage": "Kết nối page",
        "cancel": "Hủy",
        "editPage": "Cập nhật",
        "savePage": "Lưu page",
        "disconnectPage": "Ngắt kết nối",
        "addPage": "Thêm page",
        "removePage": "Xóa page"
      },
      "dialog": {
        "connectTitle": "Kết nối page Pancake",
        "editTitle": "Cập nhật page",
        "disconnectTitle": "Ngắt kết nối page",
        "disconnectMessage": "Ngắt kết nối “{{name}}”? Hội thoại đã lưu trên DentOS vẫn giữ. Page này sẽ không gửi/nhận tin mới.",
        "disconnectLast": "Ngắt kết nối “{{name}}”? Đây là page cuối — messaging sẽ tắt. Hội thoại đã lưu vẫn giữ.",
        "rotateSecret": "Tạo secret webhook mới? Cần cập nhật URL trên Pancake, secret cũ sẽ ngừng hoạt động."
      },
      "messages": {
        "saved": "Đã lưu cấu hình messaging",
        "saveError": "Không lưu được cấu hình messaging",
        "loadError": "Không tải được cấu hình messaging",
        "secretRotated": "Đã tạo webhook secret mới — hãy copy URL ngay (chỉ hiện một lần).",
        "copiedUrl": "Đã copy URL webhook",
        "copyUrlError": "Không copy được URL webhook",
        "copyUrlMissing": "Chưa có URL webhook. Kết nối page hoặc tạo secret trước.",
        "enabledNeedsPage": "Bật messaging cần ít nhất một page đã kết nối.",
        "tokenRequired": "Page {{pageId}} cần page_access_token (page mới hoặc chưa lưu token).",
        "pageIdRequired": "Cần Page ID để kết nối.",
        "pageConnected": "Đã kết nối page",
        "pageUpdated": "Đã cập nhật page",
        "pageDisconnected": "Đã ngắt kết nối page"
      }
    },
    "voicecloud": {
      "title": "VoiceCloud (ZNS / SMS)",
      "subtitle": "Gửi SMS Brandname và ZNS theo tổ chức. Trạng thái đến người dùng lấy từ DLR, không phải phản hồi API ban đầu. Đăng URL DLR trên Portal VoiceCloud.",
      "readOnly": "Chỉ quản trị viên mới chỉnh được cấu hình tích hợp.",
      "oaTitle": "Zalo OA",
      "oaEmpty": "Chưa liên kết Official Account.",
      "fields": {
        "enabled": "Bật VoiceCloud",
        "smsBrandname": "Brandname SMS",
        "authorizationKey": "API Key (AUTHORIZATION_KEY)",
        "authorizationKeyHint": "Để trống nếu giữ key đã lưu.",
        "currentKey": "Key hiện tại",
        "smsFailover": "Failover SMS khi ZNS thất bại",
        "dlrSecret": "Secret DLR",
        "dlrUrl": "URL callback DLR",
        "oaId": "OA ID",
        "oaIdFallback": "OA ID (nếu cửa sổ VoiceCloud báo thành công mà DentOS chưa cập nhật)",
        "balance": "Số dư Portal",
        "templateCount": "{{count}} mẫu đang ENABLE",
        "testTo": "SĐT gửi thử (84…)"
      },
      "actions": {
        "save": "Lưu VoiceCloud",
        "test": "Gửi SMS thử",
        "rotateDlrSecret": "Tạo secret DLR mới",
        "connectOa": "Liên kết Zalo OA",
        "reconnectOa": "Liên kết lại Zalo OA",
        "saveOaId": "Lưu OA ID",
        "syncTemplates": "Đồng bộ mẫu ZNS",
        "refreshBalance": "Lấy số dư"
      },
      "messages": {
        "saved": "Đã lưu cấu hình VoiceCloud",
        "saveError": "Không lưu được cấu hình VoiceCloud",
        "loadError": "Không tải được cấu hình VoiceCloud",
        "testQueued": "Đã xếp hàng SMS thử",
        "testError": "Gửi SMS thử thất bại",
        "oaConnected": "Đã liên kết Zalo OA",
        "oaError": "Không lấy được URL OAuth Zalo OA",
        "oaPopupBlocked": "Trình duyệt chặn cửa sổ OAuth. Hãy cho phép popup rồi thử lại.",
        "oaCallbackMissing": "Cửa sổ VoiceCloud đã đóng nhưng DentOS chưa nhận OA ID. Nhập OA ID bên dưới hoặc liên kết lại.",
        "oaCompleteError": "VoiceCloud đã ủy quyền OA nhưng DentOS không lưu được. Thử liên kết lại hoặc nhập OA ID.",
        "templatesSynced": "Đã đồng bộ mẫu ZNS",
        "templatesError": "Đồng bộ mẫu thất bại",
        "balanceOk": "Đã cập nhật số dư",
        "balanceError": "Không lấy được số dư"
      },
      "deliveries": {
        "title": "Lịch sử gửi gần đây",
        "empty": "Chưa có lần gửi nào.",
        "loadError": "Không tải được lịch sử gửi.",
        "columns": {
          "time": "Thời gian",
          "to": "Người nhận",
          "channel": "Kênh",
          "status": "Trạng thái",
          "error": "Lỗi"
        }
      }
    },
    "omicall": {
      "title": "Omicall (nghe / gọi)",
      "subtitle": "Đăng ký máy nhánh trên trình duyệt để nghe và gọi. Dán URL webhook sang Omicall để ghi nhật ký cuộc gọi.",
      "fields": {
        "enabled": "Bật Omicall",
        "apiKey": "API Key",
        "apiKeyHint": "Để trống nếu giữ key đã lưu.",
        "currentKey": "Key hiện tại",
        "sipRealm": "Domain tổng đài (SIP Realm)",
        "hotline": "Số hotline gọi ra",
        "webhookSecret": "Secret webhook",
        "webhookUrl": "URL webhook cuộc gọi",
        "staff": "Nhân sự",
        "extension": "Máy nhánh"
      },
      "placeholders": {
        "sipRealm": "Ví dụ: omiteam",
        "hotline": "Ví dụ: 02873022488",
        "staff": "Chọn nhân sự",
        "extension": "Chọn máy nhánh"
      },
      "actions": {
        "save": "Lưu Omicall",
        "test": "Kiểm tra kết nối",
        "rotateWebhookSecret": "Tạo secret webhook mới",
        "assign": "Gán máy nhánh",
        "unassign": "Gỡ",
        "syncHistory": "Kéo lịch sử cuộc gọi"
      },
      "messages": {
        "saved": "Đã lưu cấu hình Omicall",
        "saveError": "Không lưu được cấu hình Omicall",
        "loadError": "Không tải được cấu hình Omicall",
        "testOk": "Kết nối Omicall thành công",
        "testError": "Không kết nối được Omicall",
        "assigned": "Đã gán máy nhánh",
        "unassigned": "Đã gỡ máy nhánh",
        "assignError": "Không gán được máy nhánh",
        "synced": "Đã đối soát {{count}} cuộc gọi",
        "syncError": "Không kéo được lịch sử Omicall"
      },
      "history": {
        "title": "Đối soát lịch sử",
        "from": "Từ ngày",
        "to": "Đến ngày"
      },
      "extensions": {
        "title": "Máy nhánh",
        "empty": "Chưa gán máy nhánh nào.",
        "remoteEmpty": "Không lấy được danh sách máy nhánh từ Omicall."
      }
    }
  },

  "backupRestore": {
    "title": "Sao lưu & Khôi phục",
    "backupSettings": "Cài đặt sao lưu",
    "dataSelection": "Lựa chọn dữ liệu sao lưu",
    "fields": {
      "autoBackup": "Bật sao lưu tự động",
      "backupFrequency": "Tần suất sao lưu",
      "backupEncryption": "Bật mã hóa sao lưu",
      "backupLocation": "Vị trí sao lưu",
      "lastBackup": "Sao lưu lần cuối: {{date}}",
      "includePatientRecords": "Bao gồm hồ sơ bệnh nhân",
      "includeFinancialData": "Bao gồm dữ liệu tài chính",
      "includeSystemSettings": "Bao gồm cài đặt hệ thống"
    },
    "backupFrequencyOptions": {
      "daily": "Hàng ngày",
      "weekly": "Hàng tuần",
      "monthly": "Hàng tháng"
    },
    "backupLocationOptions": {
      "local": "Lưu trữ cục bộ",
      "cloud": "Lưu trữ trên mây",
      "external": "Ổ đĩa ngoài"
    },
    "actions": {
      "createBackupNow": "Tạo sao lưu ngay",
      "restoreFromBackup": "Khôi phục từ sao lưu",
      "factoryReset": "Khôi phục cài đặt gốc"
    },
    "dialogs": {
      "restoreTitle": "Khôi phục từ sao lưu",
      "restoreMessage": "Sao lưu & khôi phục chưa khả dụng. Hành động này sẽ ghi đè dữ liệu hiện tại.",
      "factoryResetTitle": "Khôi phục cài đặt gốc",
      "factoryResetMessage": "Khôi phục cài đặt gốc chưa khả dụng. Hành động này sẽ xóa toàn bộ dữ liệu và không thể hoàn tác."
    }
  },

  "automation": {
    "pageTitle": "Tự động hóa",
    "title": "Quy tắc tự động hóa",
    "tabsAria": "Chuyển giữa quy tắc và lịch sử chạy",
    "tabs": {
      "rules": "Quy tắc",
      "runs": "Lịch sử chạy"
    },
    "infoNotice": "Rule Engine chạy bất đồng bộ (outbox). Quy tắc hệ thống có thể tắt/sửa nội dung; không xóa. Bật/tắt kênh notify ở Cài đặt → Thông báo. Action cập nhật/đổi trạng thái cần quyền automation:mutate.",
    "addRule": "Thêm quy tắc",
    "searchPlaceholder": "Tìm quy tắc hoặc lịch sử chạy…",
    "emptySearch": "Không có kết quả khớp với từ khóa tìm kiếm.",
    "systemBadge": "Hệ thống",
    "systemTriggerLocked": "Quy tắc hệ thống không đổi được trigger. Có thể tắt hoặc sửa nội dung thông báo.",
    "addCondition": "Thêm điều kiện",
    "addTaskAction": "Thêm tạo task",
    "addNotifyAction": "Thêm thông báo",
    "addUpdateEntityAction": "Cập nhật lead",
    "addSetStatusAction": "Đổi trạng thái",
    "updateEntityHelp": "Chỉ áp dụng khi payload có leadId (trigger lead.*). Chỉ các field whitelist được ghi.",
    "noConditions": "Không có điều kiện — rule sẽ khớp mọi event của trigger.",
    "templateHints": "Chèn placeholder vào action đầu tiên:",
    "loading": "Đang tải quy tắc...",
    "empty": "Chưa có quy tắc nào. Tạo quy tắc đầu tiên để tự động hóa follow-up lead.",
    "noPermission": "Bạn không có quyền xem quy tắc tự động hóa.",
    "loadError": "Không tải được danh sách quy tắc.",
    "saveError": "Không lưu được quy tắc.",
    "confirmDelete": "Xóa quy tắc \"{{name}}\"?",
    "runsTitle": "Lịch sử chạy",
    "refreshRuns": "Làm mới",
    "loadingRuns": "Đang tải lịch sử...",
    "emptyRuns": "Chưa có lần chạy nào.",
    "loadRunsError": "Không tải được lịch sử chạy.",
    "filters": {
      "trigger": "Bộ lọc",
      "title": "Lọc lịch sử chạy",
      "reset": "Xóa lọc",
      "apply": "Áp dụng",
      "rule": "Quy tắc",
      "status": "Trạng thái",
      "selectRule": "Chọn quy tắc",
      "selectStatus": "Chọn trạng thái",
      "dateRange": "Khoảng thời gian",
      "dateRangePlaceholder": "Chọn khoảng ngày"
    },
    "filterRule": "Lọc theo quy tắc",
    "filterStatus": "Lọc theo trạng thái",
    "filterAll": "Tất cả",
    "filterAllRules": "Tất cả quy tắc",
    "filterAllStatuses": "Tất cả trạng thái",
    "notMatched": "Không khớp điều kiện",
    "mutatePermissionHint": "Cần quyền automation:mutate để thêm action cập nhật lead / đổi trạng thái.",
    "openTemplates": "Mở mẫu tin",
    "runStatus": {
      "success": "Thành công",
      "partial": "Một phần",
      "failed": "Thất bại",
      "skipped": "Bỏ qua",
      "running": "Đang chạy",
      "rate_limit": "Giới hạn tần suất"
    },
    "validation": {
      "nameRequired": "Tên quy tắc là bắt buộc",
      "actionsRequired": "Cần ít nhất một hành động"
    },
    "messages": {
      "created": "Đã tạo quy tắc",
      "updated": "Đã cập nhật quy tắc",
      "deleted": "Đã xóa quy tắc"
    },
    "table": {
      "name": "Tên",
      "system": "Hệ thống",
      "description": "Mô tả",
      "trigger": "Trigger",
      "actions": "Actions",
      "conditionsShort": "đk",
      "cooldown": "Cooldown",
      "noCooldown": "—",
      "enabled": "Bật",
      "priority": "Độ ưu tiên",
      "clinics": "Phòng khám",
      "systemKey": "Mã hệ thống",
      "createdAt": "Ngày tạo",
      "createdBy": "Người tạo",
      "updatedAt": "Ngày sửa",
      "updatedBy": "Người sửa",
      "manage": "Quản lý",
      "edit": "Chỉnh sửa",
      "history": "Lịch sử",
      "rowActions": "Thao tác quy tắc"
    },
    "runsTable": {
      "time": "Thời gian",
      "rule": "Quy tắc",
      "trigger": "Trigger",
      "status": "Trạng thái",
      "attempts": "Lần thử",
      "detail": "Chi tiết"
    },
    "dialog": {
      "createTitle": "Tạo quy tắc tự động",
      "editTitle": "Sửa quy tắc tự động"
    },
    "builder": {
      "createTitle": "Tạo quy tắc tự động",
      "editTitle": "Sửa quy tắc tự động",
      "back": "Quay lại",
      "namePlaceholder": "Tên quy tắc…",
      "enabledShort": "Bật",
      "advanced": "Nâng cao",
      "palette": "Thêm bước",
      "paletteCondition": "Điều kiện",
      "paletteTask": "Tạo task",
      "paletteNotify": "Thông báo",
      "paletteUpdate": "Cập nhật lead",
      "paletteStatus": "Đổi trạng thái",
      "paletteSms": "Gửi SMS",
      "paletteZns": "Gửi ZNS",
      "paletteEmail": "Gửi email",
      "toolbar": "Thêm bước",
      "selectNode": "Chọn một node trên canvas để chỉnh sửa.",
    "reorderHint": "Kéo node lên/xuống để đổi thứ tự (cần ≥2 điều kiện hoặc ≥2 hành động).",
      "nodeTrigger": "Trigger",
      "nodeCondition": "Điều kiện #{{index}}",
      "nodeAction": "Hành động #{{index}}",
      "deleteNode": "Xóa bước này",
      "templateHints": "Chèn placeholder vào action đang chọn:",
    "slashHint": "Gõ / để chèn biến động (ví dụ {{leadName}}).",
    "slashMenuTitle": "Chèn biến",
      "summaryLabel": "Tóm tắt",
      "summaryWhen": "KHI {{trigger}}",
      "summaryAnyEvent": "NẾU (mọi event)",
      "summaryIf": "NẾU {{conditions}}",
      "summaryAnd": "VÀ",
      "summaryCond": "{{field}} {{op}} {{value}}",
      "summaryCondExists": "{{field}} tồn tại",
      "summaryThen": "THÌ {{actions}}",
      "summaryAction": "{{type}} (#{{index}})",
      "validation": {
        "missing_trigger": "Thiếu trigger",
        "missing_action": "Cần ít nhất một hành động",
        "empty_name": "Tên quy tắc là bắt buộc",
        "invalid_chain": "Chuỗi workflow không hợp lệ"
      }
    },
    "sections": {
      "condition": "Điều kiện (AND, tùy chọn)",
      "action": "Hành động"
    },
    "fields": {
      "name": "Tên quy tắc",
      "description": "Mô tả",
      "enabled": "Bật quy tắc",
      "priority": "Độ ưu tiên",
      "cooldownSeconds": "Cooldown (giây)",
      "cooldownSecondsHelp": "0 = không giới hạn. Trùng eventKey trong cửa sổ này sẽ bị bỏ qua.",
      "trigger": "Trigger",
      "conditionField": "Trường điều kiện",
      "conditionFieldHelp": "Ví dụ: assigneeId, status, customerSource.",
      "conditionOp": "Toán tử",
      "conditionValue": "Giá trị",
      "conditionValueInHelp": "Nhập nhiều giá trị, cách nhau bởi dấu phẩy",
      "actionType": "Loại hành động",
      "notifyTitle": "Tiêu đề thông báo",
      "notifyMessage": "Nội dung thông báo",
      "recipientMode": "Người nhận",
      "permission": "Permission key",
      "staffIds": "Nhân viên nhận thông báo",
      "taskTitle": "Tiêu đề công việc",
      "taskDescription": "Mô tả công việc",
      "taskPriority": "Độ ưu tiên task",
      "dueOffsetDays": "Hạn sau (ngày)",
      "assigneeMode": "Cách gán người thực hiện",
      "staffId": "Người được gán",
      "assigneeField": "Field payload chứa Staff ID",
      "assigneeIdOptional": "Gán assignee (tùy chọn)",
      "treatmentInterest": "Nhu cầu điều trị",
      "entityType": "Loại entity",
      "status": "Trạng thái mới",
      "lostReason": "Lý do lost",
      "smsMessage": "Nội dung SMS",
      "znsSendTemplate": "Mẫu gửi ZNS",
      "znsSendTemplatePlaceholder": "Chọn mẫu đã map",
      "znsSendTemplateEmpty": "Chưa có mẫu gửi. Tạo mẫu trên Gửi tin → Mẫu tin, map biến ZNS sang trường CRM.",
      "znsLegacyHint": "Quy tắc cũ dùng mã mẫu vendor {{templateId}}. Chọn mẫu gửi đã map để thay.",
      "znsTemplateId": "Mã mẫu ZNS",
      "znsParams": "Biến mẫu (JSON)",
      "znsParamsHelp": "Map tên biến mẫu ZNS sang placeholder, ví dụ {\"customer_name\":\"{{patientName}}\"}.",
      "emailSubject": "Tiêu đề email",
      "emailMessage": "Nội dung email"
    },
    "messagingToPatientHelp": "Gửi tới bệnh nhân liên quan (lấy SĐT/email từ lịch hẹn hoặc patientId).",
    "triggers": {
      "lead.created": "Lead được tạo",
      "lead.status_changed": "Lead đổi trạng thái",
      "appointment.created": "Lịch hẹn được tạo",
      "appointment.confirmed": "Lịch hẹn được xác nhận",
      "appointment.arrived": "Lịch hẹn được tiếp nhận",
      "appointment.cancelled": "Lịch hẹn bị hủy",
      "appointment.rescheduled": "Lịch hẹn đổi lịch",
      "appointment.no_show": "Bệnh nhân không đến (no-show)",
      "appointment.reminder": "Nhắc lịch hẹn",
      "patient.created": "Bệnh nhân mới",
      "payment.received": "Nhận thanh toán",
      "inventory.low_stock": "Kho sắp hết",
      "treatment.completed": "Hoàn thành điều trị",
      "warranty.activated": "Kích hoạt bảo hành",
      "labo.order.status_changed": "Đơn lab đổi trạng thái",
      "task.overdue": "Công việc quá hạn",
      "task.due_soon": "Công việc sắp đến hạn",
      "time_off.created": "Đơn xin nghỉ được tạo",
      "time_off.approved": "Đơn xin nghỉ được duyệt",
      "time_off.rejected": "Đơn xin nghỉ bị từ chối",
      "time_off.cancelled": "Đơn xin nghỉ bị hủy"
    },
    "actionTypes": {
      "notify": "Gửi thông báo",
      "create_task": "Tạo công việc",
      "update_entity": "Cập nhật lead",
      "set_status": "Đổi trạng thái",
      "send_sms": "Gửi SMS",
      "send_zns": "Gửi ZNS",
      "send_email": "Gửi email"
    }
  },

  "documentNumbering": {
    "title": "Số chứng từ",
    "navAria": "Danh sách loại chứng từ",
    "status": {
      "dirty": "Chưa lưu",
      "saved": "Đã lưu"
    },
    "adminOnlyWarning": "Chỉ quản trị viên mới có thể chỉnh sửa quy tắc đánh số.",
    "infoNotice": "Lưu từng loại chứng từ. Mã đã cấp không đổi. Quy tắc chỉ áp dụng cho chứng từ mới. Đổi kiểu reset sẽ bắt đầu kỳ số mới. Đổi thứ tự hoặc hậu tố không reset số. Số bắt đầu chỉ áp dụng kỳ hiện tại.",
    "saveSuccess": "Đã lưu quy tắc đánh số.",
    "saveRowSuccess": "Đã lưu quy tắc {{doctype}}.",
    "saveRow": "Lưu quy tắc này",
    "discardRow": "Hoàn tác quy tắc này",
    "configureSubtitle": "Cấu hình định dạng mã {{doctype}}",
    "sampleLabel": "Xem trước mã mẫu",
    "tokenOrder": "Thứ tự hiển thị",
    "tokenOrderHelp": "Kéo thả để sắp xếp thứ tự các thành phần trong mã",
    "sections": {
      "structure": "Cấu trúc mã",
      "options": "Cấu hình",
      "order": "Thứ tự hiển thị"
    },
    "helpers": {
      "prefix": "1–4 chữ cái, đứng trước mã",
      "suffix": "Tùy chọn, 0–3 chữ cái, đứng sau mã",
      "startSequence": "Chỉ áp dụng cho kỳ hiện tại",
      "padding": "Số chữ số của phần số (3–8)",
      "resetPeriod": "Khi bắt đầu chu kỳ mới, phần số sẽ được reset"
    },
    "moveTokenLeft": "Chuyển {{token}} sang trái",
    "moveTokenRight": "Chuyển {{token}} sang phải",
    "tokens": {
      "year": "Năm",
      "month": "Tháng",
      "day": "Ngày",
      "seq": "Số"
    },
    "startSequenceHelper": "Chỉ áp dụng kỳ hiện tại. Kỳ mới bắt đầu từ 1 trừ khi lưu lại.",
    "resetPeriods": {
      "none": "Không reset",
      "year": "Theo năm",
      "month": "Theo tháng",
      "day": "Theo ngày"
    },
    "saveFailed": "Không lưu được quy tắc đánh số.",
    "columns": {
      "doctype": "Chứng từ",
      "prefix": "Tiền tố",
      "suffix": "Hậu tố",
      "year": "Năm",
      "month": "Tháng",
      "day": "Ngày",
      "padding": "Số chữ số",
      "resetPeriod": "Reset số",
      "startSequence": "Số bắt đầu",
      "dateParts": "Thành phần ngày",
      "yearFormat": "Định dạng năm",
      "preview": "Xem trước",
      "actions": "Thao tác"
    },
    "partFormats": {
      "month": "2 chữ số (08)",
      "day": "2 chữ số (11)",
      "seq": "{{count}} chữ số"
    },
    "yearFormats": {
      "none": "Không",
      "yy": "2 chữ số (26)",
      "yyyy": "4 chữ số (2026)"
    },
    "doctypes": {
      "patient": "Bệnh nhân",
      "lead": "Lead",
      "appointment": "Lịch hẹn",
      "treatmentPlan": "Kế hoạch điều trị",
      "payment": "Thanh toán",
      "income": "Phiếu thu",
      "expense": "Phiếu chi",
      "labOrder": "Đơn labo",
      "stockReceipt": "Nhập kho",
      "stockIssue": "Xuất kho",
      "stockTransfer": "Chuyển kho",
      "stocktake": "Kiểm kho",
      "staff": "Nhân sự",
      "prescription": "Đơn thuốc",
      "walletTransaction": "Giao dịch TK nạp trước",
      "timeOff": "Đơn phép",
      "payrollEntry": "Phiếu lương",
      "commissionSlip": "Phiếu hoa hồng"
    }
  },

  "outbound": {
    "pageTitle": "Gửi tin",
    "tabsAria": "Kênh gửi tin",
    "tabs": {
      "zns": "ZNS / SMS",
      "templates": "Mẫu tin",
      "email": "Email"
    },
    "openPage": "Mở trang Gửi tin",
    "notConfigured": "VoiceCloud chưa được bật hoặc chưa có API key. Cấu hình tại Cài đặt → Tích hợp.",
    "configure": "Cấu hình VoiceCloud",
    "balanceUnset": "Chưa lấy số dư",
    "manualOa": "Nhập OA ID thủ công nếu cửa sổ VoiceCloud đã đóng mà DentOS chưa cập nhật.",
    "searchPlaceholder": "Số điện thoại",
    "emptySearch": "Không có tin khớp bộ lọc.",
    "rowActions": "Thao tác tin",
    "filters": {
      "trigger": "Bộ lọc",
      "title": "Bộ lọc",
      "reset": "Đặt lại",
      "apply": "Áp dụng",
      "dateRange": "Khoảng ngày",
      "dateRangePlaceholder": "Chọn khoảng ngày",
      "source": "Nguồn gửi",
      "channel": "Kênh",
      "outcome": "Kết quả",
      "selectSource": "Tất cả nguồn",
      "selectChannel": "Tất cả kênh",
      "selectOutcome": "Tất cả kết quả"
    },
    "health": {
      "balanceLabel": "Số dư",
      "balanceAmount": "{{amount}} ₫",
      "balanceLoading": "Đang lấy số dư…",
      "balanceEmpty": "—"
    },
    "issue": {
      "noOa": "Chưa liên kết Zalo OA — chưa gửi được ZNS.",
      "balanceZero": "Số dư Portal bằng 0 — tin mới có thể bị từ chối.",
      "balanceError": "Không lấy được số dư Portal.",
      "deliveriesError": "Không tải được lịch sử gửi."
    },
    "actions": {
      "test": "Gửi thử",
      "testTitle": "Gửi SMS thử",
      "testHint": "Tin thử đi cùng cổng với tin thật. Dùng số dạng 84…",
      "more": "Thêm thao tác",
      "retry": "Gửi lại"
    },
    "messages": {
      "retryQueued": "Đã xếp hàng gửi lại.",
      "retryError": "Không gửi lại được tin này."
    },
    "status": {
      "delivered": "Đã tới",
      "sending": "Đang gửi",
      "failed": "Thất bại"
    },
    "channels": {
      "zns": "ZNS",
      "sms": "SMS"
    },
    "sources": {
      "automation": "Tự động hóa",
      "test": "Gửi thử",
      "reminder": "Nhắc lịch",
      "manual": "Thủ công"
    },
    "columns": {
      "content": "Nội dung",
      "source": "Nguồn"
    },
    "templates": {
      "add": "Thêm mẫu",
      "edit": "Sửa mẫu",
      "delete": "Xóa mẫu",
      "deleteConfirm": "Xóa mẫu gửi “{{name}}”? Automation đang chọn mẫu này sẽ cần chọn lại.",
      "empty": "Chưa có mẫu gửi. Đồng bộ mẫu ZNS rồi map param sang trường CRM.",
      "name": "Tên mẫu gửi",
      "vendorTemplate": "Mẫu ZNS (Portal)",
      "vendorPlaceholder": "Chọn mẫu đã đồng bộ",
      "noVendorTemplates": "Chưa có mẫu ZNS gửi được. Mở menu ⋯ và chọn Đồng bộ mẫu ZNS.",
      "bindings": "Map biến mẫu",
      "kindField": "Trường CRM",
      "kindLiteral": "Giá trị cố định",
      "optionalUnbound": "Không map",
      "literalPlaceholder": "Nhập giá trị cố định",
      "sendable": "Gửi được",
      "notSendable": "Mẫu vendor không gửi được",
      "created": "Đã tạo mẫu gửi",
      "updated": "Đã lưu mẫu gửi",
      "deleted": "Đã xóa mẫu gửi",
      "saveError": "Không lưu được mẫu gửi",
      "deleteError": "Không xóa được mẫu gửi",
      "searchPlaceholder": "Tên mẫu hoặc mã ZNS",
      "emptySearch": "Không có mẫu khớp tìm kiếm.",
      "loadError": "Không tải được danh sách mẫu.",
      "rowActions": "Thao tác mẫu",
      "columns": {
        "name": "Tên mẫu",
        "vendor": "Mẫu ZNS",
        "params": "Biến",
        "status": "Trạng thái"
      },
      "fields": {
        "patientName": "Tên bệnh nhân",
        "appointmentDate": "Ngày hẹn",
        "appointmentTime": "Giờ hẹn",
        "clinicName": "Tên phòng khám",
        "dentistName": "Tên bác sĩ",
        "reasonForVisit": "Lý do khám",
        "serviceName": "Tên dịch vụ",
        "warrantyType": "Loại bảo hành",
        "warrantyMonths": "Số tháng bảo hành",
        "warrantyEndsAt": "Ngày hết bảo hành",
        "warrantySerial": "Số serial bảo hành"
      }
    },
    "email": {
      "searchPlaceholder": "Email hoặc tiêu đề",
      "emptySearch": "Không có email khớp bộ lọc.",
      "filters": {
        "source": "Nguồn",
        "status": "Trạng thái",
        "selectSource": "Tất cả nguồn",
        "selectStatus": "Tất cả trạng thái"
      }
    }
  },

  "comingSoon": {
    "message": "Tính năng {{feature}} sẽ sớm ra mắt. Bạn có thể xem trước giao diện dưới đây, nhưng chưa thể lưu thay đổi."
  }
}
